<template>
    <b-form-group
            v-if="dataVisible"
            class="c-text"
            :description="description"
            :label="label"
            :label-for="id"
            :label-cols="labelCols"
            :aria-describedby="id + '_InvalidFeedback'">
        <date-picker
                v-if="readOnly === false"
                :mode="mode"
                v-model="dataValue"
                :color="color"
                :locale="local"
                :is-dark="isDark"
                :is-inline="isInline"></date-picker>
        <label v-if="readOnly === true">{{Core.Date.readableDate(dataValue)}}</label>
        <b-form-invalid-feedback :id="id + '_InvalidFeedback'">
            {{invalidFeedbackMessage}}
        </b-form-invalid-feedback>
    </b-form-group>
</template>

<script>
    import Vue from 'vue'
    import Calendar from 'v-calendar/lib/components/calendar.umd'
    import DatePicker from 'v-calendar/lib/components/date-picker.umd'

    // Register components in your 'main.js'
    Vue.component('calendar', Calendar)
    Vue.component('date-picker', DatePicker)

    export default {
      name: 'InputDatePicker',
        components: {
        },
      props: {
          columns: {
              type: Object,
              default: function() {
                  return { default: 1, lg: 1 }
              }
          },
          mode: {
              type: String,
              default: 'single'
          },
          color: {
              type: String,
              default: 'gray'
          },
          isDark: {
              type: Boolean,
              default: false
          },
          isInline: {
              type: Boolean,
              default: false
          },
          required: {
              type: Boolean,
              default: false
          },
          local: {
              type: String,
              default: 'fr'
          },
          value: {
              type: Date | String,
              default: function() {
                  return new Date()
              }
          },
          id: {
              type: String,
              default: ''
          },
          label: {
              type: String,
              default: ''
          },
          placeholder: {
              type: String,
              default: ''
          },
          description: {
              type: String,
              default: ''
          },
          labelCols: {
              type: Number,
              default: 0
          },
          readOnly: {
              type: Boolean,
              default: false
          },
          invalidFeedbackMessage: {
              type: String,
              default: ''
          },
          form: {
              type: Object,
              default: function() {return {}}
          },
          fieldRefs: {
              type: Array,
              default: function() { return [] }
          }
      },
      watch: {
          value(val) {
              this.dataValue = val
          },
          dataValue(val) {
              this.$emit('input', val)
              this.$emit('onChange', val, this.form.$model, this.fieldRefs)
          }
      },
      computed: {
          isVisible: {
              set(val) {
                  this.dataVisible = val
              },
              get() {
                  return this.dataVisible
              }
          }
      },
      mounted() {
          this.dataValue = this.value
      },
      data: () => {
          return {
              Vue: Vue,
              Core: window.Core,
              dataValue: null,
              dataVisible: true
          }
      },
      methods: {
          chkState(val) {
              if (this.form !== undefined && this.form[val] !== undefined) {
                  const field = this.form[val]
                  return !field.$dirty || !field.$invalid
              }
          }
      }
  }
</script>